import React, { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api } from "../../lib/api";

export const ImportUploadStep = ({ onParsed }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!file) return toast.error("Choose a .xlsx or .csv file");
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/directory-import/parse", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`Read ${data.row_count} rows — headers found on row ${data.header_row}`);
      onParsed(data);
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not read the file"); } finally { setBusy(false); }
  };
  return (
    <div className="nv-card p-6 space-y-4 max-w-2xl" data-testid="import-upload-step">
      <label className="block text-xs font-semibold text-slate-600">Directory file (.xlsx or .csv, max 10 MB)
        <input type="file" accept=".xlsx,.csv" onChange={(e) => setFile(e.target.files?.[0] || null)} className="mt-1.5 w-full text-sm" data-testid="import-file-input" />
      </label>
      <ul className="text-xs text-slate-500 list-disc pl-5 space-y-1">
        <li>Title or explanation rows above the headers are detected automatically.</li>
        <li>People are matched by Staff ID (if a column exists) and then by exact email. Names only suggest possible matches — you decide.</li>
        <li>Blank cells never erase existing information; nobody is deactivated for being absent from the file.</li>
        <li>No invitations or password emails are sent by the import.</li>
      </ul>
      <button onClick={submit} disabled={busy} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-sky-700 text-white text-sm hover:bg-sky-800 disabled:opacity-50" data-testid="import-parse-button"><Upload size={15} /> {busy ? "Reading…" : "Read file"}</button>
    </div>
  );
};
